import { render, staticRenderFns } from "./FilterGood.vue?vue&type=template&id=5f3ae9c7&scoped=true&"
import script from "./FilterGood.vue?vue&type=script&lang=js&"
export * from "./FilterGood.vue?vue&type=script&lang=js&"
import style0 from "./FilterGood.vue?vue&type=style&index=0&id=5f3ae9c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ae9c7",
  null
  
)

export default component.exports